module.exports = __webpack_public_path__ + "img/report-icon.49fefaa1.svg";